import i18n from './index'

/** Job / QC status label for UI chrome (not job titles). */
export function translateJobStatus(status: string): string {
  const key = `status.${status}`
  const translated = i18n.t(key, { ns: 'common' })
  if (translated && translated !== key) return translated
  if (status === 'pending_review' || status === 'under_review') {
    return i18n.t('status.under_review', { ns: 'common' })
  }
  return status.replace(/_/g, ' ')
}

export function translatePriority(priority: string): string {
  const key = `priority.${priority}`
  const translated = i18n.t(key, { ns: 'common' })
  if (translated && translated !== key) return translated
  return priority
}

/** Property access_type enum values shown on field cards. */
export function translateAccessType(accessType: string | null | undefined): string {
  if (!accessType) return ''
  const key = `accessType.${accessType}`
  const translated = i18n.t(key, { ns: 'common' })
  if (translated && translated !== key) return translated
  return accessType
}
